import React, { useMemo, useState, useEffect } from 'react';
import { useTypedSelector } from '@hooks';
import { Button } from 'antd';
import { updateAssetVersionDescription } from '@api/Asset';
import PanelSection from '@pages/MediaViewer/components/PanelSection';
import { formatDetails } from '@pages/MediaViewer/Details/utils';
import { useResponsive } from '@hooks/useResponsive';

import { ReactComponent as PlusSvg } from '@assets/icons/MediaViewer/plus.svg';

import './Details.less';

type DetailsProps = {
  onClosePanel?: () => void;
};

function Details({ onClosePanel }: DetailsProps) {
  const { isMdWidth } = useResponsive();
  const assets = useTypedSelector(({ mediaViewer }) => mediaViewer.assets);
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );
  const getData = useMemo(
    () => formatDetails({ assets, selectedVersion }),
    [selectedVersion]
  );
  const isOwnerOfAsset = assets?.owner?.user?.me;
  const [detailsDescription, setDetailsDescription] = useState<string>('');
  const [isShowDescription, setIsShowDescription] = useState<boolean>(false);

  useEffect(() => {
    setDetailsDescription(selectedVersion?.description || '');
    setIsShowDescription(Boolean(selectedVersion?.description));
  }, [selectedVersion]);

  const onSaveDescription = async () => {
    if (selectedVersion?.id) {
      await updateAssetVersionDescription({
        assetVersionId: selectedVersion.id,
        description: detailsDescription
      });
      if (!detailsDescription) setIsShowDescription(false);
    }
  };

  const btnAddDescription =
    !isShowDescription && !detailsDescription && isOwnerOfAsset ? (
      <Button
        icon={<PlusSvg className="b-icon-plus" />}
        className="media_viewer_details-btn"
        type="link"
        onClick={(e) => {
          e.stopPropagation();
          setIsShowDescription(true);
        }}
      >
        Description
      </Button>
    ) : null;

  return (
    <PanelSection
      name="Details"
      extraction={btnAddDescription}
      onClose={onClosePanel}
    >
      <div className="media_viewer_inner media_viewer_details">
        {isMdWidth && btnAddDescription}
        {selectedVersion && (
          <div className="media_viewer_details-container">
            {isShowDescription && (
              <div className="media_viewer_details-block b-block-full">
                <div className="media_viewer_details-item">
                  <div className="media_viewer_details-label">Description</div>
                  {isOwnerOfAsset ? (
                    <input
                      type="text"
                      className="media_viewer_details-input"
                      value={detailsDescription}
                      onChange={(e) => setDetailsDescription(e.target.value)}
                      onBlur={() => onSaveDescription()}
                    />
                  ) : (
                    <div className="media_viewer_details-value">
                      {detailsDescription}
                    </div>
                  )}
                </div>
              </div>
            )}
            {getData.map((item: any, index: number) => (
              <div
                className={`media_viewer_details-block ${
                  index === 0 ? 'b-block-full' : ''
                }`}
                key={`media_viewer_details-block-${index}`}
              >
                <div className="media_viewer_details-item">
                  <div className="media_viewer_details-label">{item.label}</div>
                  <div className="media_viewer_details-value">{item.value}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </PanelSection>
  );
}

export default Details;
